import React from "react";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import PageHeader from "src/app/components/PageHeader/PageHeader";
import {
  PaneTopbar,
  PaneTopbarLeft,
} from "src/app/components/Pane/PaneTopbar/PaneTopbar";

export default function CreateNewProjectPaneHeader() {
  return (
    <PaneTopbar>
      <PaneTopbarLeft>
        <PageHeader
          title={
            <IDHFormattedMessage
              id="ws_create_new_project"
              defaultMessage="Create new project"
            />
          }
          description={
            <IDHFormattedMessage
              id="ws_create_new_project_description"
              defaultMessage="Create a new campaign based on your current creator search. If you select creators, they will be available in this campaign."
            />
          }
        />
      </PaneTopbarLeft>
    </PaneTopbar>
  );
}
